import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Shared marketing footer. Product links jump to landing sections; company links are real pages.
export default function SiteFooter() {
  const { t } = useTranslation();
  return (
    <footer className="border-t border-border mt-24" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-12 grid md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-3 h-3 bg-intl" />
            <span className="font-app font-bold">AI Visibility OS</span>
          </Link>
          <p className="mt-4 text-sm text-muted-foreground max-w-md">{t("footer.tagline")}</p>
        </div>
        <div className="text-sm font-app">
          <div className="text-xs uppercase tracking-widest text-muted-foreground mb-3">{t("footer.product")}</div>
          <ul className="space-y-2">
            <li><Link to="/#features" className="hover:text-intl transition-colors">{t("footer.features")}</Link></li>
            <li><Link to="/#how" className="hover:text-intl transition-colors">{t("footer.how")}</Link></li>
            <li><Link to="/#pricing" className="hover:text-intl transition-colors">{t("footer.pricing")}</Link></li>
          </ul>
        </div>
        <div className="text-sm font-app">
          <div className="text-xs uppercase tracking-widest text-muted-foreground mb-3">{t("footer.company")}</div>
          <ul className="space-y-2">
            <li><Link to="/about" data-testid="footer-about" className="hover:text-intl transition-colors">{t("footer.about")}</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy" className="hover:text-intl transition-colors">{t("footer.privacy")}</Link></li>
            <li><Link to="/terms" data-testid="footer-terms" className="hover:text-intl transition-colors">{t("footer.terms")}</Link></li>
            <li><Link to="/refund" data-testid="footer-refund" className="hover:text-intl transition-colors">{t("legal.linkRefund")}</Link></li>
            <li><Link to="/faq" data-testid="footer-faq" className="hover:text-intl transition-colors">{t("legal.linkFaq")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-5 text-center font-mono text-xs text-muted-foreground">
          <span data-testid="footer-copyright">© 2026 AI Visibility OS</span>
        </div>
      </div>
    </footer>
  );
}
